import {MuWidget} from "mu-widget/lib/MuWidget";

export type BarMeterData = {
    points: BarMeterPoint[];
    value: number;
    min: number;
    max: number;
    color: string|{
        color: string;
        value: number;
    }[];
    label: string;
}

export type BarMeterPoint = {
    value: number;
    color: string;
}

export class BarMeter extends MuWidget {
    beforeIndex() {
        this.container.classList.add('bar-meter');
        this.muAppendContent(`
            <div mu="points" class="bar-meter__points">
                <span class="bar-meter__point" mu=":.@point"></span>
            </div>
            <div mu="meter" class="bar-meter__meter"></div>
            <div mu="label" class="bar-meter__label"></div>
        `);
    }

    // @ts-ignore
    protected data: BarMeterData;
    muBindData(data: BarMeterData) {
        console.log(data);
        this.data = data;
        const pointValues = data.points.map(p => p.value);
        const allValues = [data.value, ...pointValues, data.min, data.max];

        const effectiveMin = Math.min(...allValues);
        const effectiveMax = Math.max(...allValues);
        const range = effectiveMax - effectiveMin;

        const factor = range !== 0 ? 100 / range : 0;

        const toPercent = (val: number) => (val - effectiveMin) * factor;

        this.ui.points.innerHTML = '';
        const width = toPercent(data.value);
        this.ui.meter.style.setProperty('--value', width.toString() + '%');
        this.ui.meter.style.setProperty('--color', this.getColorForValue(data.value));
        for (const point of data.points) {
            const el = this.muWidgetFromTemplate('point', 'points').container;
            el.style.setProperty('--position', toPercent(point.value) + "%");
            el.style.setProperty('--color', point.color);
        }
        this.ui.label.textContent = data.label;
    }

    /**
     * Linearly interpolates between two hex colors.
     * @param color1 - Výchozí barva (Hex).
     * @param color2 - Cílová barva (Hex).
     * @param factor - Poměr (0-1).
     */
    protected interpolateColor(color1: string, color2: string, factor: number): string {
        const parseHex = (hex: string) => hex.replace('#', '').match(/.{2}/g)!.map(x => parseInt(x, 16));
        const [r1, g1, b1] = parseHex(color1);
        const [r2, g2, b2] = parseHex(color2);

        const r = Math.round(r1 + (r2 - r1) * factor);
        const g = Math.round(g1 + (g2 - g1) * factor);
        const b = Math.round(b1 + (b2 - b1) * factor);

        const toHex = (n: number) => n.toString(16).padStart(2, '0');
        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    }

    /**
     * Gets the color for a specific value based on the color scale.
     */
    protected getColorForValue(value: number): string {
        if (typeof this.data.color === "string") return this.data.color;
        if (this.data.color.length === 0) return '#ffffff00';

        const sortedScale = [...this.data.color]
            .sort((a, b) => a.value - b.value);

        if (value <= sortedScale[0].value) return sortedScale[0].color;

        if (value >= sortedScale[sortedScale.length - 1].value) {
            return sortedScale[sortedScale.length - 1].color;
        }

        for (let i = 0; i < sortedScale.length - 1; i++) {
            const start = sortedScale[i];
            const end = sortedScale[i + 1];

            if (value >= start.value && value <= end.value) {
                const range = end.value - start.value;
                const factor = range !== 0 ? (value - start.value) / range : 0;
                return this.interpolateColor(start.color, end.color, factor);
            }
        }

        return sortedScale[0].color;
    }

}